const API_URL = "https://ims.holdthechild.net";

export const getToken = () => localStorage.getItem("token");

// Submit (Create or Edit) Capacity Activity
export const submitCapacityActivity = async (data, isEdit = false) => {
  const token = getToken();
  if (!token) throw new Error("Unauthorized");

  const config = {
    method: isEdit && data._id ? "PUT" : "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };

  const url = isEdit && data._id
    ? `${API_URL}/api/capacity-activities/${data._id}`
    : `${API_URL}/api/capacity-activities`;

  const response = await fetch(url, config);
  if (!response.ok) throw new Error("Failed to save capacity activity");
  return response.json();
};

// Get paginated capacity activities
export const getPaginatedCapacityActivities = async (page = 1, limit = 10) => {
  const token = getToken();
  if (!token) throw new Error("Unauthorized");

  const response = await fetch(
    `${API_URL}/api/capacity-activities?page=${page}&limit=${limit}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) throw new Error("Failed to fetch capacity activities");

  return response.json(); // expects { data: [...], totalPages: N }
};
